import { Card, Skeleton, Space } from "antd";
import React from "react";
import { FallbackPageContent } from "./FallbackPageContent";

/** Table/list page skeleton (header row + table body). */
export const TableListPageContentFallback: React.FC = () => (
  <FallbackPageContent aria-label="Loading list">
    <Space direction="vertical" size="middle" style={{ width: "100%" }}>
      <Card size="small">
        <Skeleton active paragraph={{ rows: 1 }} />
      </Card>
      <Card>
        <Skeleton active paragraph={{ rows: 8 }} />
      </Card>
    </Space>
  </FallbackPageContent>
);
